import BifrostDevice from "./bifrost-device"
import GatewayDevice from "./gateway-device"
import TR069Device from "./tr069-device"

let bifrostModels = ['GF1200', 'W5-1200F', 'W4-300F', 'W5-1200G', 'W5-2100G', 'Bifrost mock', 'Twibi Force Plug', 'Twibi Force AX', 'Twibi Force AX G2', 'W6-1500','W6-1500S', 'Twibi Force Voice', 'Twibi Force Plug Giga', 'EX-1500', 'W5-1200GS', 'W4-300S','TW-3000','W6-3000','W6-1500 G2','W6-1500 Slim']
const bifrostInMeshModels = [
    'GF1200',
    'W5-1200F',
    'W5-1200G',
    'W5-2100G',
    'W5-1200GS',
    'Twibi Force Plug',
    'Twibi Force AX',
    'Twibi Force AX G2',
    'Twibi Force Plug Giga',
    'RX1500',
    'RX3000',
    'W6-1500',
    'W6-1500S',
    'W6-1500 Slim',
    'W6-3000',
    'W6-1500 G2',
]
let rfoGatewayModels = ['WiFiber 121 AC', 'ONT 121 W', /*'Huawei EG8145V5', 'Huawei EG8141A5', 'Huawei HG8546M',*/'ONU R1', 'WiFiber 120 AC', 'WiFiber 1200 R', 'WiFiber AX 1800', 'WiFiber AX 1800V', '140 PoE', 'WiFiber AX 3000V', 'Fiberhome HG6145F3', 'Fiberhome HG6145F', 'Fiberhome HG6145D2', "Fiberhome HG6145D","Fiberhome HG5853SF"]
let modelsHOMultiplesWANs = ['SR1041E',"SR1041F","SR1021F"]
let gateway = ['gw-tr069']
let oemModelsHO = ['Twibi', 'ACtion RG1200', 'RX-1500', 'RX-3000']
let mockModels = ['CPE-MOCK', 'tr069-mock']
let modelsfiberhome = ["SR1041E","SR1041F", "SR1021F", "Fiberhome HG6145F", "Fiberhome HG6145F3", "Fiberhome HG6145D2", "Fiberhome HG6145D", "Fiberhome HG5853SF"];
let modelsfiberhomeBridge = ["Fiberhome HG6145F", "Fiberhome HG6145F3", "Fiberhome HG6145D2", "Fiberhome HG6145D", "Fiberhome HG5853SF"];
let modelsfiberhomeTr143 = ["Fiberhome HG6145F", "Fiberhome HG6145F3", "Fiberhome HG6145D2","WiFiber 120 AC", "WiFiber 1200 R", "WiFiber AX 1800", "WiFiber AX 1800V","WiFiber AX 3000V","WiFiber 121 AC", "Fiberhome HG6145D", "Fiberhome HG5853SF"];
let wpa3models = ["SR1041E","SR1041F", "SR1021F"];
//list of models in development to remove management option on production environment
let modelToHidden = ['']

const modelsCustomize = {
    "SR1041E": true, 
    "SR1041F": true, 
    "SR1021F": true, 
    "Fiberhome HG6145F": false, //pendente
    "Fiberhome HG6145F3": true, 
    "Fiberhome HG6145D2": false, //pendente
    "Fiberhome HG6145D": false,  //pendente
    "Fiberhome HG5853SF": false, //pendente
    "WiFiber 120 AC": true, 
    "WiFiber 1200 R": true, 
    "WiFiber AX 1800": true, 
    "WiFiber AX 1800V": true, 
    "WiFiber AX 3000V": true, 
    "WiFiber 121 AC": true
};


function hiddenManagementProduction() {

    if (window.location.hostname === 'remotize.intelbras.com.br') {

        if (modelToHidden.length === 0) return

        modelToHidden.forEach((model) => {
            bifrostModels = bifrostModels.filter(item => item !== model)
            rfoGatewayModels = rfoGatewayModels.filter(item => item !== model)
            gateway = gateway.filter(item => item !== model)
            oemModelsHO = oemModelsHO.filter(item => item !== model)
            modelsHOMultiplesWANs = modelsHOMultiplesWANs.filter(item => item !== model)
            modelToHidden = modelToHidden.filter(item => item !== model)
        });
    }
}

function getDeviceType(model) {
    if (bifrostModels.includes(model) || mockModels.includes(model))
        return 'bifrost'

    if (rfoGatewayModels.includes(model) || oemModelsHO.includes(model) || modelsHOMultiplesWANs.includes(model))
        return 'tr069'

    if (gateway.includes(model)) {
        return 'gateway'
    }

    console.log('DeviceFactory - Unknown model:', model)

    return 'unknown'
}

var DeviceFactory = {

    getDevice: (device, backend) => {
        switch (getDeviceType(device.model)) {
            case 'bifrost':
                return new BifrostDevice(device, backend)
            case 'tr069':
                return new TR069Device(device, backend)
            case 'gateway':
                return new GatewayDevice(device, backend)
            default:
                throw Error('Unknown device model')
        }
    },

    haveManagementAPI: (device) => {

        hiddenManagementProduction()

        if (bifrostModels.includes(device.model)) {
            const [major, minor] = device.fw_version ? device.fw_version.split('.').map(v => isNaN(v) ? v : Number(v)) : ['0', '0']
            return (major > 1 || (major === 1 && minor >= 11))
        }
        if (gateway.includes(device.model)) {
            return true
        }

        if (rfoGatewayModels.includes(device.model)) {
            return true
        }

        if (oemModelsHO.includes(device.model)) {
            return true
        }

        if (modelsHOMultiplesWANs.includes(device.model)) {
            return true
        }

        if (mockModels.includes(device.model)) {
            return true
        }
    },

    isTR069: (model) => {
        return rfoGatewayModels.includes(model) || oemModelsHO.includes(model) || modelsHOMultiplesWANs.includes(model)
    },

    hasBifrostInMesh: (model) => {
        return bifrostInMeshModels.includes(model)
    },

    isFiberhomeModels: (model) => {
        return modelsfiberhome.includes(model)
    },

    isWPA3Models: (model) => {
        return wpa3models.includes(model)
    },


    isGateway: (model) => {
        return gateway.includes(model)
    },

    isRFO: (model) => {
        return rfoGatewayModels.includes(model)
    },
    isMultiplesWANs: (model) => {
        return modelsHOMultiplesWANs.includes(model) || rfoGatewayModels.includes(model)
    },
    isHOMultiplesWANs: (model) => {
        return modelsHOMultiplesWANs.includes(model)
    },

    isFHBridge: (model) => {
        return modelsfiberhomeBridge.includes(model)
    },
    isTr143: (model) => {
        return modelsfiberhomeTr143.includes(model)
    },
    isModelsCustomize: (model) => {
        return modelsCustomize[model] === true
    }    
}

export default DeviceFactory
